import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import TextField from '@mui/material/TextField'

// TODO: create type for controllerfield props based on its ControlledField render props
const EncountersCancellationReasonOtherInput: FC<unknown> = ({ ...controlledFieldProps }) => {
  const { t } = useTranslation()

  return (
    <TextField
      id="encounters-cancelled-reason-other"
      name="cancellationReasonOther"
      fullWidth
      multiline
      rows={4}
      label={t('components:ui.Inputs.EncountersCancellationOtherInput.label')}
      placeholder={t('components:ui.Inputs.EncountersCancellationOtherInput.placeholder')}
      {...controlledFieldProps}
    />
  )
}

export default EncountersCancellationReasonOtherInput
